import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import _get from 'lodash/get';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Components
import FontIcon from '../../../../../atoms/FontIcon';
import Button from '../../../../../atoms/Button';
var ActionIcon = /*#__PURE__*/function (_PureComponent) {
  _inherits(ActionIcon, _PureComponent);
  var _super = _createSuper(ActionIcon);
  function ActionIcon() {
    var _this;
    _classCallCheck(this, ActionIcon);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var onActionClick = _this.props.onActionClick;
      e.stopPropagation();
      var actionId = _get(e, 'currentTarget.dataset.actionid');
      onActionClick(actionId);
    });
    return _this;
  }
  _createClass(ActionIcon, [{
    key: "render",
    value: function render() {
      var _this$props$action = this.props.action,
        action = _this$props$action === void 0 ? EMPTY_OBJECT : _this$props$action;
      var id = action.id,
        disabled = action.disabled,
        icon = action.icon,
        iconSize = action.iconSize,
        color = action.color,
        _action$tabIndex = action.tabIndex,
        tabIndex = _action$tabIndex === void 0 ? 0 : _action$tabIndex;
      return /*#__PURE__*/React.createElement(Button, {
        view: Button.VIEW.ICON,
        "data-actionid": id,
        onClick: this.handleClick,
        disabled: disabled,
        tabIndex: tabIndex
      }, /*#__PURE__*/React.createElement(FontIcon, {
        size: iconSize,
        color: color
      }, icon));
    }
  }]);
  return ActionIcon;
}(PureComponent);
ActionIcon.propTypes = {
  action: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    icon: PropTypes.string,
    iconSize: PropTypes.string,
    tabIndex: PropTypes.number
  }).isRequired,
  onActionClick: PropTypes.func
};
ActionIcon.defaultProps = {
  onActionClick: noop
};
export default ActionIcon;